import React, { useState } from "react";
import { MapPin, Phone, Clock, Search } from "lucide-react";
import InfoPage from "./Infopage";

// TODO: replace with your real stores.
const STORES = [
  {
    name: "NinetyOne Main Store",
    city: "City A",
    address: "123 Main Street, City A",
    phone: "+000 000 000 001",
    hours: "Mon–Sat 8:00–19:00, Sun 10:00–16:00",
  },
  {
    name: "NinetyOne Central Mall",
    city: "City B",
    address: "Level 1, Central Mall, City B",
    phone: "+000 000 000 002",
    hours: "Mon–Sun 9:00–20:00",
  },
  {
    name: "NinetyOne Market Road",
    city: "City C",
    address: "45 Market Road, City C",
    phone: "+000 000 000 003",
    hours: "Mon–Sat 8:30–18:00",
  },
];

function StoreLocator() {
  const [query, setQuery] = useState("");
  const q = query.trim().toLowerCase();
  const results = STORES.filter((s) =>
    [s.name, s.city, s.address].some((v) => v.toLowerCase().includes(q)),
  );

  return (
    <InfoPage
      title="Store locator"
      intro="Find a NinetyOne store near you. Search by city, area or store name."
    >
      <div className="info-search">
        <Search className="info-search-icon" aria-hidden="true" />
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by city or store name"
          aria-label="Search stores"
        />
      </div>

      <p className="info-count" aria-live="polite">
        {results.length} {results.length === 1 ? "store" : "stores"} found
      </p>

      <div className="info-stores">
        {results.map((s) => (
          <article key={s.name} className="info-store">
            <h2 className="info-h3">{s.name}</h2>
            <p className="info-store-row">
              <MapPin aria-hidden="true" />
              {s.address}
            </p>
            <p className="info-store-row">
              <Phone aria-hidden="true" />
              <a
                className="info-link"
                href={`tel:${s.phone.replace(/\s/g, "")}`}
              >
                {s.phone}
              </a>
            </p>
            <p className="info-store-row">
              <Clock aria-hidden="true" />
              {s.hours}
            </p>
            <a
              className="info-btn info-btn--secondary"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s.address)}`}
              target="_blank"
              rel="noreferrer"
            >
              Get directions
            </a>
          </article>
        ))}
        {results.length === 0 && (
          <p className="info-text">
            No stores match "{query}". Try a different city or clear the search.
          </p>
        )}
      </div>
    </InfoPage>
  );
}

export default StoreLocator;
